import React, {useContext, useEffect, useState} from 'react';
import {AuthContext} from "../AuthContext";
import {Navigate} from "react-router-dom";
import { load_fetch, isUserInRole } from "../pr_utils";
import ChordAndLyricsDisplay from "../components/ChordAndLyricsDisplay";
import Styles from "../styles/pages/SongViewer.module.css";


const SongViewer = ({ page_title }) => {
    const { authStatus } = useContext(AuthContext);

    useEffect(() => {

        const interval = setInterval(() => {
            load_fetch(
                'Security_Handler.php',
                { operation: 'KEEP_ALIVE' },
                (data) => {
                    console.log("Keep Alive");
                    console.log(data);
            });
        }, 60 * 1000);
        return () => clearInterval(interval);
    }, []);


    // Block unauthenticated users or non-admins
    if (!authStatus || !(isUserInRole(authStatus, ['ADMIN']) ||
        isUserInRole(authStatus, ['SERVICE_VIEWER']) ||
        isUserInRole(authStatus, ['SERVICE_EDITOR'])
            )) {
        return <Navigate to="/" />;
    }


    return (
        <div className={Styles.songViewerPage}>
            <ChordAndLyricsDisplay />
        </div>
    )
}

export default SongViewer;
